// extracted by mini-css-extract-plugin
module.exports = {"root":"my9z4","displayUnit":"_2IRpj","delta":"_3ijZa"};